import { createRouter, createWebHistory } from 'vue-router';
import Rooms from '@/components/pages/Rooms.vue';
import Summary from '@/components/pages/Summary.vue';

const routes = [
  { path: '/', name: 'Rooms', component: Rooms },
  { path: '/summary', name: 'Summary', component: Summary },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
